const DATA = [
  'IBM Research Accomplishment on AI Planning Technology for IBM Applications',
  'IBM Corporate Technical Recognition for Open Source Significant Contributor Award',
  "ICAPS 2023 People's Choice Best System Demonstration Award Runner-up",
  'IBM Research Accomplishment Award for Research Contributions to Watson Orchestrate',
  'IBM Annual Employee Individual Contributor Award',
  'IBM Entrepreneurship Award',
  'IBM Open Source Recognition Program Significant Contributor Award',
  'IBM Annual Employee Individual Contributor Award',
  'ICAPS 2021 Outstanding Program Committee Member Award',
  'AAAI 2021 Outstanding Senior Committee Member Award',
  'IBM Research Accomplishment Landmark for contributions to AI for Business Automation',
  'IBM Open Source Recognition Program Leadership Award',
  "ICAPS 2020 People's Choice Best System Demonstration Award",
  "IEEE AI's 10 to Watch 2020",
  "IBM Individual Contributor Award for outstanding contributions and leadership in IBM's cognitive and cloud platform",
  'ASU CIDSE 2019 Ph.D. Student of the Year',
  'ICAPS 2019 Distinguished Dissertation Award (Honorable Mention)',
  "ICAPS 2018 People's Choice Best System Demonstration Award Runner-up",
  'IBM Ph.D. Fellowship 2016-18',
  'Scholarship from Partnership of AI (PAI) to author the Landscaping Primer for the Pillar on Collaborations between People and AI',
  'Microsoft Imagine Cup 2017 US Finalist',
  'University Graduate Fellowship Award for outstanding research in Fall 2013, Spring 2014, Spring 2015, Spring 2017 and Spring 2018',
  "ICAPS 2014 People's Choice Best System Demonstration Award",
];

export default DATA;
